
import { supabase } from "@/integrations/supabase/client";

const HARRY_POTTER_QUOTES = [
  "It is our choices, Harry, that show what we truly are, far more than our abilities.",
  "Happiness can be found, even in the darkest of times, if one only remembers to turn on the light.",
  "After all this time? Always.",
  "It does not do to dwell on dreams and forget to live.",
  "We've all got both light and dark inside us. What matters is the part we choose to act on.",
  "The ones that love us never really leave us.",
  "Words are, in my not-so-humble opinion, our most inexhaustible source of magic.",
  "Of course it is happening inside your head, but why on earth should that mean it is not real?",
  "Don't let the muggles get you down.",
  "You're a wizard, Harry.",
  "Mischief managed.",
  "I solemnly swear that I am up to no good.",
  "Always use the proper name for things. Fear of a name increases fear of the thing itself.",
  "Training for the ballet, Potter?",
  "You have your mother's eyes."
];

export const messageDistributionService = {
  async sendAdminWelcomeMessage() {
    try {
      console.log('Starting admin welcome message distribution...');
      
      // Admin user ID (from context)
      const adminUserId = '7f6f85de-5e77-4fe8-99d6-783c9113d2da';
      const welcomeMessage = "Welcome to ALPHA, this is a test message and we wish you all a good hunt!";
      
      // Get all users except the admin
      const { data: users, error: usersError } = await supabase
        .from('user_profiles')
        .select('user_id')
        .eq('is_visible', true)
        .neq('user_id', adminUserId)
        .limit(100);

      if (usersError) {
        console.error('Error fetching users:', usersError);
        throw usersError;
      }

      if (!users || users.length === 0) {
        console.log('No users found');
        return { success: false, message: 'No users found' };
      }

      console.log(`Found ${users.length} users to send welcome message to`);

      const messagesToInsert = users.map(user => ({
        sender_id: adminUserId,
        receiver_id: user.user_id,
        content: welcomeMessage,
        message_type: 'system'
      }));

      // Insert all messages in batches
      const batchSize = 50;
      let totalInserted = 0;

      for (let i = 0; i < messagesToInsert.length; i += batchSize) {
        const batch = messagesToInsert.slice(i, i + batchSize);
        
        const { error: insertError } = await supabase
          .from('messages')
          .insert(batch);

        if (insertError) {
          console.error(`Error inserting batch ${i / batchSize + 1}:`, insertError);
          throw insertError;
        }

        totalInserted += batch.length;
        console.log(`Inserted batch ${i / batchSize + 1}, total: ${totalInserted} messages`);
      }

      console.log(`Successfully sent welcome message to ${totalInserted} users`);
      return { 
        success: true, 
        message: `Successfully sent welcome message to ${totalInserted} users` 
      };

    } catch (error) {
      console.error('Error in sendAdminWelcomeMessage:', error);
      return { 
        success: false, 
        message: `Error: ${error.message}` 
      };
    }
  },

  async distributeHarryPotterQuotes() {
    try {
      console.log('Starting Harry Potter quotes distribution...');
      
      // Get all users
      const { data: users, error: usersError } = await supabase
        .from('user_profiles')
        .select('user_id')
        .eq('is_visible', true)
        .limit(100); // Limit to prevent overwhelming the system

      if (usersError) {
        console.error('Error fetching users:', usersError);
        throw usersError;
      }

      if (!users || users.length === 0) {
        console.log('No users found');
        return { success: false, message: 'No users found' };
      }

      console.log(`Found ${users.length} users`);

      const messagesToInsert = [];

      // For each user, send 5 random Harry Potter quotes to every other user
      for (const sender of users) {
        for (const receiver of users) {
          // Skip sending to self
          if (sender.user_id === receiver.user_id) {
            continue;
          }

          // Select 5 random quotes
          const selectedQuotes = [...HARRY_POTTER_QUOTES]
            .sort(() => 0.5 - Math.random())
            .slice(0, 5);

          // Create messages for each quote
          for (const quote of selectedQuotes) {
            messagesToInsert.push({
              sender_id: sender.user_id,
              receiver_id: receiver.user_id,
              content: quote,
              message_type: 'text'
            });
          }
        }
      }

      console.log(`Preparing to insert ${messagesToInsert.length} messages`);

      // Insert all messages in batches to avoid overwhelming the database
      const batchSize = 100;
      let totalInserted = 0;

      for (let i = 0; i < messagesToInsert.length; i += batchSize) {
        const batch = messagesToInsert.slice(i, i + batchSize);
        
        const { error: insertError } = await supabase
          .from('messages')
          .insert(batch);

        if (insertError) {
          console.error(`Error inserting batch ${i / batchSize + 1}:`, insertError);
          throw insertError;
        }

        totalInserted += batch.length;
        console.log(`Inserted batch ${i / batchSize + 1}, total: ${totalInserted} messages`);
      }

      console.log(`Successfully distributed ${totalInserted} Harry Potter quotes`);
      return { 
        success: true, 
        message: `Successfully sent ${totalInserted} Harry Potter quotes to all users` 
      };

    } catch (error) {
      console.error('Error in distributeHarryPotterQuotes:', error);
      return { 
        success: false, 
        message: `Error: ${error.message}` 
      };
    }
  }
};
